<template>
<div class="col-xs-12">
  <button
    type="submit"
    class="btn btn-fill btn-block"
    :disabled="loading || unableToSend"
    @click.prevent="handleSelectFile()"
  >
    Enviar images
  </button>

  <input
    class="form-control"
    type="file"
    ref="filesContainer"
    accept="image/png,image/jpeg"
    style="display:none"
    multiple
    @change="handleFiles($event)"
  >

  <span v-if="filesSelected">{{ selectedFiles }}</span>

  <button
    type="submit"
    v-if="filesSelected"
    @click.prevent="handleSaveFiles()"
    :disabled="loading || unableToSend"
    class="btn btn-fill btn-block btn-success btn-wd"
  >
    <i class="ti-save"></i> Salvar
  </button>
</div>
</template>

<script>
import swal from 'sweetalert2'
import { mapActions } from 'vuex'

export default {
  name: 'BtnUploadFileInput',

  props: {
    ticket: {
      required: true,
      type: Object
    },

    event: {
      required: true,
      type: Object
    }
  },

  data () {
    return {
      saving: false,
      selectedFiles: [],
      loading: false,
      isLoadingFile: false,
      typeFiles: [],
      binaryFiles: []
    }
  },

  computed: {
    filesSelected () {
      return this.selectedFiles.length > 0
    },
    unableToSend () {
      let blockByWinnerRanking = !this.ticket.winner && this.event.winnerChoiceMode === 'ranking'
      return this.saving || !this.ticket.stockId || !this.$can('tickets.uploadDoc') || blockByWinnerRanking
    }
  },

  methods: {
    ...mapActions('tickets', ['updateState', 'updateWithView']),
    ...mapActions('docs', {
      fetchDocs: 'fetchAll',
      insertDoc: 'insert',
      insertDocAttachment: 'insertAttachment'
    }),

    handleSelectFile () {
      this.$refs.filesContainer.click()
    },

    handleFiles (data) {
      this.isLoadingFile = true

      for (let index = 0; index < data.target.files.length; index++) {
        this.selectedFiles.push(data.target.files[index].name)
        this.typeFiles.push(data.target.files[index].type)
        this.loadFile(data.target.files[index])
          .then(binaryFiles => {
            this.isLoadingFile = false
            this.binaryFiles.push(binaryFiles)
          })
      }
    },

    loadFile (file) {
      return new Promise((resolve, reject) => {
        let reader = new FileReader()
        reader.onload = function (e) {
          resolve(e.target.result)
        }
        reader.onerror = function (e) {
          reject(e)
        }
        reader.readAsArrayBuffer(file)
      })
    },

    async handleSaveFiles () {
      if (this.unableToSend) {
        return this.notifyUnable()
      }

      this.loading = true
      if (this.verifyAmountFiles()) {
        this.isLoadingFile = true
        let docId = await this.getIdDocument()
        await this.uploadDocuments(docId)

        let date = new Date()
        let newTicket = Object.assign({}, this.ticket, { documentedAt: date })

        delete newTicket.customer
        delete newTicket.event
        delete newTicket.stock

        try {
          await this.updateWithView({
            ddoc: 'tickets-by-id',
            view: 'tickets-by-id',
            payload: newTicket,
            database: 'default'
          })
          this.updateState({ documentedAt: date })
          this.resetFiles()
          this.isLoadingFile = false
          this.notifySuccess()
        } catch (e) {
          console.log(e)
        }
        this.loading = false
      }
    },

    async uploadDocuments (docId) {
      try {
        for (let index = 0; index < this.binaryFiles.length; index++) {
          await this.insertDocAttachment({
            docId,
            doc: {
              mimeType: this.typeFiles[index],
              attachmentName: this.selectedFiles[index],
              attachment: this.binaryFiles[index]
            }
          })
        }
        return true
      } catch (e) {
        console.log(e)
        return false
      }
    },

    async getIdDocument () {
      let referenceDoc = await this.fetchDocs({ where: { referenceId: this.ticket._id } })
      referenceDoc = referenceDoc.length > 0 ? referenceDoc[0] : undefined
      if (referenceDoc) {
        return referenceDoc._id
      }

      let doc = await this.insertDoc({
        'database': process.env.DB_NAME,
        'referenceId': this.ticket._id,
        'collection': 'docs'
      })

      return doc.id
    },

    verifyAmountFiles () {
      if (this.binaryFiles.length === 0) {
        this.notifyNoFile()
        return false
      } else {
        return true
      }
    },

    notifyUnable () {
      return swal({
        text: `Não é possível enviar documentação para este cliente.`,
        type: 'error',
        confirmButtonClass: 'btn btn-info btn-fill',
        buttonsStyling: false
      })
    },

    notifyNoFile () {
      return swal({
        text: `Nenhum arquivo foi selecionado.`,
        type: 'error',
        confirmButtonClass: 'btn btn-info btn-fill',
        buttonsStyling: false
      })
    },

    notifySuccess () {
      this.$notify({
        message: 'Documentação salva com sucesso.',
        type: 'success'
      })
    },

    resetFiles () {
      this.selectedFiles = []
    }
  }
}
</script>

<style scoped>
  .col-xs-12 {
    margin-bottom: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Tickets/Actions/BtnUploadFileInput.vue